module.exports = __webpack_public_path__ + "assets/user.16dc72b2.svg";